import {Component} from '@angular/core';

@Component({
  selector: 'number-node',
  templateUrl: './number-node.component.html'
})
export class NumberNodeComponent {
    node
}
